<template>
    <div class="flex mx-auto w-full max-w-md p-4 border rounded-[5px]">
        <div class="w-6 h-full flex items-center justify-center">
            <slot name="icon" />
        </div>

        <div class="ml-3 text-sm">
            <slot name="default" />
        </div>
    </div>
</template>
